<div class="px-2 lg:px-8 m-auto max-w-[1600px] pb-6 py-6 mt-12 mb-12">
  <div class="grid grid-cols-1 sm:grid-cols-2 gap-8">
    <div class="flex flex-col justify-start">
      <h1 class="text-4xl mb-8 font-bold">Trainingsflächen buchen</h1>
      <p>
        In der Halle und auf dem Aussenplatz wird auf
        <a class="text-primary-600" href="https://hundesport-sg.ch/infrastruktur/" target="_blank">Kunstrasen</a> trainiert.
      </p>
      <div class="flex flex-row gap-4">
        <a href="/assets/files/preisliste.pdf" target="_blank" download="Preisliste.pdf">
          <button class="w-full bg-white border-2 border-primary-600 hover:bg-primary-600 hover:text-white p-4 rounded-md mb-8 mt-8">
            Preisliste
          </button>
        </a>
        <a href="/assets/files/hallenordnung.pdf" target="_blank" download="Hallenordnung.pdf">
          <button class="w-full bg-white border-2 border-primary-600 hover:bg-primary-600 hover:text-white p-4 rounded-md mb-8 mt-8">
            Hallenordnung
          </button>
        </a>
      </div>
      <div>
        <app-access></app-access>
      </div>
    </div>

    <img class="h-96 w-full object-cover object-top" src="/assets/images/flugaufnahme.jpeg" alt="Halle" />
  </div>
</div>

<div class="w-full py-12 bg-primary-600 flex flex-row items-center justify-center">
  <h2 class="text-3xl font-bold text-white text-center m-0">{{ { key: 'offers' } | i18n }}</h2>
</div>

<div class="px-2 lg:px-8 m-auto max-w-[1600px] pb-6 py-6 mt-12 mb-12">
  <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-12">
    @for (option of booking.bookingOptions; track option.key) {
      <div class="hover:bg-opacity-10 hover:bg-primary-600 rounded-md p-4">
        <img class="w-full h-64 object-cover mb-12" [src]="option.image" [alt]="option.title" />
        <h3 class="text-2xl font-bold mb-8">{{ option.title }}</h3>
        <div [innerHTML]="option.designation"></div>
        <a [routerLink]="['/places/book']" [queryParams]="{ option: option.key }">
          <button class="w-full bg-white border-2 border-primary-600 hover:bg-primary-600 hover:text-white p-4 rounded-md mb-8 mt-8">
            {{ { key: 'book' } | i18n }}
          </button>
        </a>
      </div>
    }
  </div>
</div>
